export default {
  en: {
    toggle_tooltip: 'Toggle tooltip',
  },
};
